module.exports = __webpack_public_path__ + "static/media/johnson.c1389ac0.webp";